module.exports = __webpack_public_path__ + "a014f6cf09b13e5208e045d4c331f35d.svg";